enum EligibilityValidationMessageType {
	EXCEPTION,
	WARNING,
	ERROR,
	INFO,
	UNKNOWN,
}

export default EligibilityValidationMessageType;